
import React from 'react';
import { ResourceFile } from "../types";
import { QuizContentTypeHandler } from "./handlers/QuizContentTypeHandler";
import { InteractiveContentTypeHandler } from "./handlers/InteractiveContentTypeHandler";
import { MediaContentTypeHandler } from "./handlers/MediaContentTypeHandler";

interface ContentTypeHandlerProps {
  currentFile: ResourceFile;
  currentFileIndex: number;
  files: ResourceFile[];
  isQuizView: boolean;
  isFreeResponseView: boolean;
  isDragDropView: boolean;
  isLinkingView: boolean;
  isTrainee: boolean;
  isAdmin: boolean;
  isFileLocked: (index: number) => boolean;
  completedFiles: {[key: string]: boolean};
  overallProgress: number;
  resourceId: string;
  quiz: any;
  isLoadingQuiz: boolean;
  quizCompleted: boolean;
  quizAttempt: any;
  handleQuizComplete: (quizId: string, attempt: any) => Promise<void>;
  handleContentComplete: () => void;
  handleDragDropComplete: (fileId: string, attempt: any) => Promise<void>;
  onComplete?: () => void;
  onError: (error: string) => void;
  error?: string | null;
}

export function ContentTypeHandler({
  currentFile,
  currentFileIndex,
  files,
  isQuizView,
  isFreeResponseView,
  isDragDropView,
  isLinkingView,
  isTrainee,
  isAdmin,
  isFileLocked,
  completedFiles,
  overallProgress,
  resourceId,
  quiz,
  isLoadingQuiz,
  quizCompleted,
  quizAttempt,
  handleQuizComplete,
  handleContentComplete,
  handleDragDropComplete,
  onComplete,
  onError,
  error
}: ContentTypeHandlerProps) {
  // Handle Quiz content
  if (isQuizView) {
    return (
      <QuizContentTypeHandler
        currentFile={currentFile}
        currentFileIndex={currentFileIndex}
        files={files}
        completedFiles={completedFiles}
        isAdmin={isAdmin}
        isTrainee={isTrainee}
        isFileLocked={isFileLocked}
        overallProgress={overallProgress}
        resourceId={resourceId}
        quiz={quiz}
        isLoadingQuiz={isLoadingQuiz}
        quizCompleted={quizCompleted}
        quizAttempt={quizAttempt}
        handleQuizComplete={handleQuizComplete}
        onComplete={onComplete}
        error={error}
      />
    );
  }

  // Handle Interactive content (free response, drag drop, linking)
  if (isFreeResponseView || isDragDropView || isLinkingView) {
    return (
      <InteractiveContentTypeHandler
        currentFile={currentFile}
        resourceId={resourceId}
        isFreeResponseView={isFreeResponseView}
        isDragDropView={isDragDropView}
        isLinkingView={isLinkingView}
        handleContentComplete={handleContentComplete}
        handleDragDropComplete={handleDragDropComplete}
      />
    );
  }

  // Handle media content (PDF, Video) with fallbacks
  return (
    <MediaContentTypeHandler
      currentFile={currentFile}
      resourceId={resourceId}
      isTrainee={isTrainee}
      isAdmin={isAdmin}
      handleContentComplete={handleContentComplete}
      onError={onError}
    />
  );
}
